import script from "./WhyElectric.vue?vue&type=script&setup=true&lang=js"
export * from "./WhyElectric.vue?vue&type=script&setup=true&lang=js"

import "./WhyElectric.vue?vue&type=style&index=0&id=11f592b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11f592b8"]])

export default __exports__